// TSS vite/03 §"Query keys convention". `events` first: that is the resource
// read, so an invalidation of events (a decision, an approval) reaches these.
export const auditKeys = {
    events: (params) => ['events', 'authorship', params],
};
